import React from "react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import CustomSelect from "../../components/CustomSelect";
import CustomInput from "../../components/CustomInput";
import CustomPhoneInput from "../../components/CustomPhoneNumberInput";

function CreateUser({ formData, handleInputChange, occupations }) {
  console.log("formData=============",formData);
  const handlePhoneChange = (value, name) => {
    // Pass the value directly without stripping the '+'
    handleInputChange({
      target: { name, value: value || "" }, // Use value or an empty string to avoid passing 'undefined'
    });
  };

  const titleArray = [
    { label: "Mr.", value: "MR" },
    { label: "Mrs.", value: "MRS" },
    { label: "Ms.", value: "MS" },
  ];
  const genderArray = [
    { value: "MALE", label: "Male" },
    { value: "FEMALE", label: "Female" },
    { value: "OTHER", label: "Other" },
  ];

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-y-2 gap-x-3 mt-2">
        <CustomSelect
          label={"Title"}
          name="title"
          value={formData.title}
          onChange={handleInputChange}
          options={titleArray}
          required
        />

        {/* <div>
          <label className="flex text-sm font-normal text-slate-500 mb-1 text-nowrap items-center gap-1">
            Title
          </label>
          <select
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            className="w-full px-2 py-2 border border-slate-300 rounded-md focus:border-flamingo-500 focus:ring-0 focus:outline-none transition-colors duration-200 bg-white"
          >
            <option value="MR">Mr.</option>
            <option value="MRS">Mrs.</option>
            <option value="MS">Ms.</option>
          </select>
        </div> */}

        <CustomInput
          label={"First Name"}
          name="firstName"
          value={formData.firstName}
          onChange={handleInputChange}
          required
        />
        <CustomInput
          label={"Last Name"}
          name="lastName"
          value={formData.lastName}
          onChange={handleInputChange}
          required
        />
        <CustomSelect
          label={"Gender"}
          name="gender"
          value={formData.gender}
          onChange={handleInputChange}
          options={genderArray}
          required
        />
        <CustomSelect
          label={"Occupation"}
          name="occupation"
          value={formData.occupation}
          onChange={handleInputChange}
          options={occupations.map((occupation, index) => ({
            value: occupation,
            label: occupation,
          }))}
          required
        />
        <CustomInput
          label={"Date Of Birth"}
          name="dob"
          type="date"
          value={formData.dob}
          onChange={handleInputChange}
          required
        />
        <CustomPhoneInput
          label="WhatsApp Number"
          international
         type="tel"
          defaultCountry="IN"
          name="mobileNoWa"
          value={formData.mobileNoWa}
          onChange={(value) => handlePhoneChange(value, "mobileNoWa")}
          required
        />
        <CustomPhoneInput
          label="Calling Number"
          name="mobileNoCalling"
          type="tel"
          value={formData.mobileNoCalling}
          international
          defaultCountry="IN"
          onChange={(value) => handlePhoneChange(value, "mobileNoCalling")}
          required
        />

        <CustomInput
          label={"Email"}
          name="emailId"
          type="email"
          className="md:col-span-2 xl:col-span-4"
          value={formData.emailId}
          onChange={handleInputChange}
          required
        />

        {/* <div>
          <label className="block text-sm font-medium text-gray-700">
            First Name
          </label>
          <input
            name="occupation"
            value={formData.occupation}
            onChange={handleInputChange}
            className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Last Name
          </label>
          <input
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
            className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Gender
          </label>
          <select
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
          >
            <option value="MALE">Male</option>
            <option value="FEMALE">Female</option>
            <option value="OTHER">Other</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Occupation
          </label>
          <select
            name="occupation"
            value={formData.occupation}
            onChange={handleInputChange}
            className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
          >
            <option value="">Select Occupation</option>
            {occupations.map((occupation, index) => (
              <option key={index} value={occupation}>
                {occupation}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Date of Birth
          </label>
          <input
            name="dob"
            type="date"
            value={formData.dob}
            onChange={handleInputChange}
            className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            WhatsApp Number
          </label>
          <PhoneInput
            name="mobileNoWa"
            value={formData.mobileNoWa}
            onChange={(value) => handlePhoneChange(value, "mobileNoWa")}
            international
            defaultCountry="IN"
            className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Contact Number
          </label>
          <PhoneInput
            name="mobileNoCalling"
            value={formData.mobileNoCalling}
            international
            defaultCountry="IN"
            onChange={(value) => handlePhoneChange(value, "mobileNoCalling")}
            className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Email
          </label>
          <input
            name="emailId"
            type="email"
            value={formData.emailId}
            onChange={handleInputChange}
            className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            required
          />
        </div> */}
      </div>

      <div className="mt-4">
        <h4 className="font-medium">Address Details</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-y-2 gap-x-3">
          <CustomInput
            type="text"
            label={"Building No"}
            name="address.buildingNo"
            value={formData.address.buildingNo}
            onChange={handleInputChange}
            required
          />
          <CustomInput
            label="Street Name 1"
            name="address.streetName1"
            value={formData.address.streetName1}
            onChange={handleInputChange}
            required
          />
          <CustomInput
            label="Street Name 2"
            name="address.streetName2"
            value={formData.address.streetName2}
            onChange={handleInputChange}
            required
          />
          <CustomInput
            label="City"
            name="address.city"
            value={formData.address.city}
            onChange={handleInputChange}
            required
          />
          <CustomInput
            required
            label="District"
            name="address.district"
            value={formData.address.district}
            onChange={handleInputChange}
          />
          <CustomInput
            required
            label="Pin Code"
            name="address.pinCode"
            value={formData.address.pinCode}
            onChange={handleInputChange}
          />
          <CustomInput
            required
            label="State"
            name="address.state"
            value={formData.address.state}
            onChange={handleInputChange}
          />
          <CustomInput
            required
            label="Country"
            name="address.country"
            value={formData.address.country}
            onChange={handleInputChange}
          />
        </div>
        {/* <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Building No
            </label>
            <input
              name="address.buildingNo"
              value={formData.address.buildingNo}
              onChange={handleInputChange}
              className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Street Name 1
            </label>
            <input
              name="address.streetName1"
              value={formData.address.streetName1}
              onChange={handleInputChange}
              className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Street Name 2
            </label>
            <input
              name="address.streetName2"
              value={formData.address.streetName2}
              onChange={handleInputChange}
              className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              City
            </label>
            <input
              name="address.city"
              value={formData.address.city}
              onChange={handleInputChange}
              className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              District
            </label>
            <input
              name="address.district"
              value={formData.address.district}
              onChange={handleInputChange}
              className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Pin Code
            </label>
            <input
              name="address.pinCode"
              value={formData.address.pinCode}
              onChange={handleInputChange}
              className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              State
            </label>
            <input
              name="address.state"
              value={formData.address.state}
              onChange={handleInputChange}
              className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Country
            </label>
            <input
              name="address.country"
              value={formData.address.country}
              onChange={handleInputChange}
              className="mt-1 w-full bg-gray-50 border border-gray-300 rounded-md p-2 text-sm"
            />
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default CreateUser;
